/**
 * Elevar ATC
 * @param {object} data
 * @param {object} opts
 */
function elevarTracking(data, eventType) {
  // global variables
  const products = [
    {
      id: data.sku, // SKU
      name: data.product_title, // Product title
      brand: data.vendor,
      category: data.product_type,
      variant: data.variant_title,
      price: `${data.price}`,
      quantity: `${data.quantity}`, // Not required for dl_select_item & dl_view_item
      list: data.product_type, // The list the product was discovered from
      product_id: `${data.product_id}`, // The product_id
      variant_id: `${data.variant_id}`, // id or variant_id
      compare_at_price: `${data.compare_at_price || '0.0'}`, // If available on dl_view_item & dl_add_to_cart otherwise use "0.0"
      image: data.image || '', // If available, otherwise use an empty string
      inventory: `${data.inventory_quantity || ''}`, // If available, only required on dl_view_item
    },
  ];

  let userProperties = { visitor_type: 'guest' };
  if (Array.isArray(window.ElevarDataLayer)) {
    const userDataEvent = window.ElevarDataLayer.find(e => e?.event === 'dl_user_data');
    if (userDataEvent?.user_properties) {
      userProperties = userDataEvent.user_properties;
    }
  }

  /**
   * Init
   */
  function init() {
    if (typeof window.ElevarDataLayer === 'undefined') return;

    if (eventType === 'add') {
      handleAddEvent();
    } else if (eventType === 'remove') {
      handleRemoveEvent();
    }
  }

  /**
   * Handle Add Event
   */
  function handleAddEvent() {
    window.ElevarDataLayer.push({
      event: 'dl_add_to_cart',
      user_properties: userProperties,
      ecommerce: {
        currencyCode: 'USD',
        add: {
          actionField: {
            list: window.location.pathname,
          },
          products,
        },
      },
    });
  }

  /**
   * Handle Remove Event
   */
  function handleRemoveEvent() {
    window.ElevarDataLayer.push({
      event: 'dl_remove_from_cart',
      user_properties: userProperties,
      ecommerce: {
        currencyCode: 'USD',
        remove: {
          actionField: {
            list: window.location.pathname,
          },
          products,
        },
      },
    });
  }

  return init();
}

export default elevarTracking;
